// Map of routes to their display titles. Shared by MainLayout's header and
// the report flow (which captures the title of whatever page is reported).
export const routeTitles: Record<string, string> = {
  "/create": "Create a story",
  "/": "Unique Minds",
  "/home": "Unique Minds",
  "/characters": "Characters",
  "/characters/retired": "Retired Characters",
  "/profiles": "Profiles",
  "/adoption-center": "Adoption Hub",
  "/my-stuff": "My Stuff",
  "/prize-machine": "Prize Machine",
  "/my-stuff/stories": "Stories",
  "/my-stuff/memories": "Activity Memories",
  "/my-stuff/smile-progress": "Smile Routine Progress",
  "/my-stuff/dental-stories": "Pre-Visit Stories",
  "/my-stuff/dental-manuals": "Dental Mind Manuals",
};

export function getRouteTitle(path: string): string | undefined {
  return routeTitles[path];
}
